<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">
      <!-- Avatar Col -->
      <div class="vx-col">
        <div class="img-container mb-4">
          <vs-avatar size="200px" :src="data.photo" :text="data.userName" />
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          class="w-full mt-4"
          label="Nome"
          v-model="data.userName"
          name="name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
          <label class="vs-input--label">Grupo</label>
          <v-select
            @input="setSelected"
            v-model="data.userGroup"
            :clearable="false"
            :options="options"
            name="grupo"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="'required'"
          />
        </div>
      </div>
      <span class="text-danger text-sm" v-show="errors.has('userGroup')">{{
        errors.first("userGroup")
      }}</span>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          class="w-full mt-4"
          label="Email"
          v-model="data.email"
          type="email"
          name="email"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{
          errors.first("email")
        }}</span>
      </div>
    </div>
    <br />
    <div class="vx-row" v-show="data.userGroup == 'admin'">
      <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
          <h6 class="mb-2">Equipamentos Visiveis</h6>
          <ul class="demo-alignment">
            <li>
              <vs-radio
                color="success"
                v-model="data.equipmentIsVisible"
                vs-value="1"
                >Sim</vs-radio
              >
            </li>
            <li>
              <vs-radio
                color="#1E90FF"
                v-model="data.equipmentIsVisible"
                vs-value="0"
                >Não</vs-radio
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="vx-row">+
      <div class="vx-col w-full">
        <div class="mt-4">
          <h6 class="mb-2">Ativo</h6>
          <ul class="demo-alignment">
            <li>
              <vs-radio color="success" v-model="data.isActive" vs-value="S"
                >Sim</vs-radio
              >
            </li>
            <li>
              <vs-radio color="danger" v-model="data.isActive" vs-value="N"
                >Não</vs-radio
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            class="ml-auto mt-2"
            @click="updateUser"
            :disabled="!isFormValid"
            >Salvar</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { baseApiUrl } from "@/global";
import { Validator } from "vee-validate";
import axios from "axios";
const dict = {
  custom: {
    name: {
      required: "Por favor insira nome",
      alpha: "Your first name may only contain alphabetic characters",
    },
    email: {
      required: "Por favor insira a senha",
      alpha: "Your first name may only contain alphabetic characters",
    },
    userGroup: {
      required: "Por favor selecione o grupo",
    },
  },
};

// register custom messages
Validator.localize("en", dict);
export default {
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      user: {},
      options: [
        { id: 1, label: "admin", userGroup: "admin" },
        { id: 2, label: "funcionario", userGroup: "funcionario" },
      ],
    };
  },
  computed: {
    isFormValid() {
      return (
        !this.errors.any() &&
        this.data.userName &&
        this.data.email &&
        this.data.userGroup
      );
    },
  },
  methods: {
    setSelected(value) {
      this.data.userGroup = value.userGroup;
    },
    async updateUser() {
      let result = this.$validator.validateAll();
      if (result) {
        try {
          if (this.data.userGroup == "funcionario") {
            this.data.equipmentIsVisible = 1;
          }

          this.user = {
            idUser: this.data.idUser,
            userName: this.data.userName,
            email: this.data.email,
            userGroup: this.data.userGroup,
            isActive: this.data.isActive,
            equipmentIsVisible: this.data.equipmentIsVisible,
          };

          this.$vs.loading();
          await axios.post(`${baseApiUrl}/user/updateUser`, this.user);
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Salvo",
            text: "com Sucesso",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
          this.$router.push(`/usuarios`);
        } catch (error) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: "Não foi possivel salvar " + error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      } else {
        return;
      }
    },
  },
  async created() {},
};
</script>
